exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bottom-container[data-v-33f60637]{position:fixed;left:0;bottom:0;width:100%;color:#fff;text-align:center;z-index:9999}.nav-button[data-v-33f60637]{display:inline-block;padding:5px 15px;margin-left:13px;margin-right:13px;border:1px solid #fff;font-size:16px;border-radius:5px;background-color:#fff;-webkit-transition-duration:.4s;transition-duration:.4s}.nav-button[data-v-33f60637]:hover{color:#32a6ae}.left-button[data-v-33f60637]{float:left}.right-button[data-v-33f60637]{float:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-33f60637","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/elements/buttons.vue
// module id = 144
// module chunks = 0